import React, { FunctionComponent } from 'react';

interface Props {
    children: any;
    className?: string
}

/**
 * The container of the table-head and table itself.
 * The hierarchy is as follows:
 * 
 * 
 * - HanTableContainer
 *      - HanTableHead
 *      - HanTable
 *          - HanTableRow
 *              - HanTableCell
 * @param children Place the components HanTableHead and HanTable in here respectively.
 * @param className
 */
const HanTableContainer: FunctionComponent<Props> = ({ children, className }) => {
    return (
        <div className={`han-table ${className}`}>
            {children}
        </div>
    )
}

export default HanTableContainer;
